<div class="tab-bar-root">
<!-- Pannello notifiche (bottom sheet) -->
<div class="tab-panel notif-panel" *ngIf="notifOpen">
  <div class="panel-header">
    <span class="panel-title">{{ "navbar.notifications" | translate }}</span>
    <button class="panel-mark-all" *ngIf="notif.unreadCount > 0" (click)="markAllRead()">
      {{ "navbar.mark_all_read" | translate }}
    </button>
  </div>

  <div class="panel-empty" *ngIf="notif.loading">
    <span class="notif-spinner"></span>
  </div>

  <div class="panel-empty" *ngIf="!notif.loading && notif.notifications.length === 0">
    {{ "navbar.no_notifications" | translate }}
  </div>

  <div class="panel-list" *ngIf="!notif.loading && notif.notifications.length > 0">
    <button
      *ngFor="let n of notif.notifications"
      class="panel-notif-item"
      [class.unread]="!n.read"
      (click)="markRead(n)"
    >
      <span class="panel-notif-icon"><app-icon [name]="getNotifIcon(n.type)" [size]="18" /></span>
      <span class="panel-notif-body">
        <span class="panel-notif-title">{{ n.title }}</span>
        <span class="panel-notif-msg">{{ n.message }}</span>
      </span>
      <span class="panel-notif-dot" *ngIf="!n.read"></span>
    </button>
  </div>
</div>

<!-- Pannello "Altro" (bottom sheet) -->
<div class="tab-panel more-panel" *ngIf="moreOpen">
  <div class="panel-header">
    <span class="panel-title">{{ "navbar.more" | translate }}</span>
  </div>
  <div class="more-grid">
    <button *ngFor="let l of moreLinks" class="more-link" (click)="goMore(l.path)">
      <span class="more-link-icon"><app-icon [name]="l.icon" [size]="22" /></span>
      <span>{{ l.labelKey | translate }}</span>
    </button>
  </div>
</div>

<nav class="bottom-tab-bar">
  <a routerLink="/home" routerLinkActive="active" class="tab-btn" (click)="closePanels()">
    <span class="tab-icon"><app-icon name="home" [size]="22" /></span>
    <span class="tab-label">{{ "navbar.home" | translate }}</span>
  </a>

  <a routerLink="/calendario" routerLinkActive="active" class="tab-btn" (click)="closePanels()">
    <span class="tab-icon"><app-icon name="calendar" [size]="22" /></span>
    <span class="tab-label">{{ "navbar.calendar" | translate }}</span>
  </a>

  <a routerLink="/eventi/nuovo" class="tab-btn tab-btn-cta" (click)="closePanels()">
    <span class="tab-cta-circle">+</span>
  </a>

  <button class="tab-btn" [class.active]="notifOpen" (click)="toggleNotif()">
    <span class="tab-icon-wrapper">
      <span class="tab-icon"><app-icon name="bell" [size]="22" /></span>
      <span class="tab-badge" *ngIf="notif.unreadCount > 0">{{ notif.unreadCount > 9 ? "9+" : notif.unreadCount }}</span>
    </span>
    <span class="tab-label">{{ "navbar.notifications" | translate }}</span>
  </button>

  <button class="tab-btn" [class.active]="moreOpen" (click)="toggleMore()">
    <span class="tab-icon"><app-icon name="more" [size]="22" /></span>
    <span class="tab-label">{{ "navbar.more" | translate }}</span>
  </button>
</nav>
</div>
